/**
 * @public
 * @group Enums
 * @category Playlist
 */
export enum PlaylistLayout {
    Filmstrip = 'row',
    Grid = 'grid',
    Slider = 'slider'
}